import {TypographyIconProps, TypographyWeights} from '@gwc/main'

import {ButtonProps} from './types'

type TypographyVars = {
  variant: TypographyIconProps['variant']
  thickness: TypographyWeights
}

export const getTypographyVars = ({size, variant}: ButtonProps): TypographyVars => ({
  variant: size === 'xs' ? 'caption1' : 'body2',
  thickness: variant === 'action' ? 'medium' : 'regular',
})
